<template>
    <div class="page-body">
        <div class="sub-nav" :style="{visibility: subnav.length > 0 ? 'visible' : 'none'}">
            <span v-for="(item,index) in subnav" :key="index"
                :style="{color: item.color || 'inherit'}">{{text(item)}}</span>
        </div>
        <div class="body" :class="{noborder: noborder}">
            <slot></slot>
        </div>
        <div class="loading_box" v-show='loading'>
            <div class="loading">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'Layout',
        props: {
            subnav: {
                default: ()=>([]),
                type: Array
            },
            noborder: {
                default: false,
                type: Boolean
            },
            loading: {
                default: true,
                type:Boolean
            }
        },
        methods: {
            text(item) {
                if (typeof item == 'object') {
                    return item.text
                } else if (typeof item == 'string' || typeof item == 'number') {
                    return item
                }
            }
        }
    }
</script>

<style scoped>
    .loading_box {
        position: absolute;
        left: 0px;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 3;
        background: rgb(255, 255, 255, 0);
    }

    .loading {
        width: 80px;
        height: 15px;
        position: absolute;
        left: 50%;
        top: 300px;
        margin-left: -40px;
    }

    .loading span {
        display: inline-block;
        width: 10px;
        height: 10px;
        margin-right: 5px;
        border-radius: 50%;
        background: #90c7ee;
        animation: load 1.04s ease infinite;
    }

    .loading span:last-child {
        margin-right: 0px;
    }

    @keyframes load {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    .loading span:nth-child(1) {
        animation-delay: 0.13s;
    }

    .loading span:nth-child(2) {
        animation-delay: 0.26s;
    }

    .loading span:nth-child(3) {
        animation-delay: 0.39s;
    }

    .loading span:nth-child(4) {
        animation-delay: 0.52s;
    }

    .loading span:nth-child(5) {
        animation-delay: 0.65s;
    }


    .page-body {
        /* margin-left: 10px; */
        box-shadow: 0 0 5px #aaa;
        position: relative;
    }

    .body {
        background: #fff;
    }

    .body.noborder {
        border: 0;
    }

    .sub-nav {
        width: 100%;
        height: 60px;
        line-height: 60px;
        font-size: 15px;
        text-indent: 25px;
        background: white;
        /* color: #bc0101; */
        box-sizing: border-box;
        color: #333333;
        font-weight: bold;
    }

    .sub-nav span::after {
        content: '>';
        color: #333333;
        margin-left: 6px;
        margin-right: 6px;
    }

    .sub-nav span:last-child::after {
        display: none;
    }

    .sub-nav span:last-child {
        /* font-weight: normal; */
    }
</style>>